import { Target, Zap, BarChart3 } from 'lucide-react';

const ITEMS = [
  { Icon: Target, title: 'Lower Risk', body: 'Market intelligence before you invest heavily in ANZ expansion.' },
  { Icon: Zap, title: 'Faster Validation', body: 'Get real sales data and consumer feedback within weeks, not months.' },
  { Icon: BarChart3, title: 'Smarter Scaling', body: 'Data-driven decisions on pricing, packaging, and market expansion.' },
];

export const ForBrands = () => (
  <section className="py-20 md:py-32 bg-gray-50">
    <div className="container mx-auto px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">For Brands</h2>
          <p className="text-xl text-gray-600">We don't ask brands to "ship and hope". We launch with intelligence.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {ITEMS.map(({ Icon, title, body }) => (
            <div key={title} className="text-center">
              <div className="h-16 w-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon className="h-8 w-8 text-[#004aad]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
              <p className="text-gray-600">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
